const db = [
  {
    header: 'for gamers by gamers',
    headerTail: 'tee',
    img: 'product1.jpg',
    imgMin: 'product1.min.jpg',
    id: '701642853695',
    price: 29.50,
    newPrice: 15.99,
    stars: 4,
    about: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit temporibus excepturi libero. Magni libero iusto, tempore sit quaerat fugiat voluptatem ducimus officiis ex temporibus ab animi labore quidem molestiae quo.',
    size: ['xs', 's', 'm', 'l']
  },
  {
    header: 'be awesome, be you',
    headerTail: 'tee',
    img: 'product2.jpg',
    imgMin: 'product2.min.jpg',
    id: '701642853696',
    price: 29.99,
    newPrice: 19.99,
    stars: 5,
    about: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit temporibus excepturi libero. Magni libero iusto, tempore sit quaerat fugiat voluptatem ducimus officiis ex temporibus ab animi labore quidem molestiae quo.',
    size: ['s', 'l']
  },
  {
    header: 'take you\'s style',
    headerTail: 'tee',
    img: 'product3.jpg',
    imgMin: 'product3.min.jpg',
    id: '701642853697',
    price: 22.00,
    newPrice: '',
    stars: 3,
    about: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit temporibus excepturi libero. Magni libero iusto, tempore sit quaerat fugiat voluptatem ducimus officiis ex temporibus ab animi labore quidem molestiae quo.',
    size: ['xs', 's', 'm', 'l', 'xl']
  },
  {
    header: 'gamer in the house',
    headerTail: 'tee',
    img: 'product4.jpg',
    imgMin: 'product4.min.jpg',
    id: '701642853698',
    price: 24.99,
    newPrice: '',
    stars: 4,
    about: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit temporibus excepturi libero. Magni libero iusto, tempore sit quaerat fugiat voluptatem ducimus officiis ex temporibus ab animi labore quidem molestiae quo.',
    size: ['xs', 's', 'm', 'l']
  },
  {
    header: 'gaming for go',
    headerTail: 'tee',
    img: 'product5.jpg',
    imgMin: 'product5.min.jpg',
    id: '701642853699',
    price: 29.99,
    newPrice: 19.99,
    stars: 5,
    about: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit temporibus excepturi libero. Magni libero iusto, tempore sit quaerat fugiat voluptatem ducimus officiis ex temporibus ab animi labore quidem molestiae quo.',
    size: [ 's', 'm', 'l']
  },
  {
    header: 'game in my soul',
    headerTail: 'tee',
    img: 'product6.jpg',
    imgMin: 'product6.min.jpg',
    id: '701642853700',
    price: 60.00,
    newPrice: '',
    stars: 5,
    about: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit temporibus excepturi libero. Magni libero iusto, tempore sit quaerat fugiat voluptatem ducimus officiis ex temporibus ab animi labore quidem molestiae quo.',
    size: [ 's', 'm', 'l']
  },
  {
    header: 'super gamer',
    headerTail: 'tee',
    img: 'product7.jpg',
    imgMin: 'product7.min.jpg',
    id: '701642853701',
    price: 54.00,
    newPrice: '',
    stars: 4,
    about: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit temporibus excepturi libero. Magni libero iusto, tempore sit quaerat fugiat voluptatem ducimus officiis ex temporibus ab animi labore quidem molestiae quo.',
    size: [ 's', 'm', 'l', 'xl']
  }
];

module.exports.db = db;


// WEBPACK FOOTER //
// ./src/assets/db/db.js